import React from 'react';
import { FiBell, FiSearch, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import './Header.css';
import wordmark from '../../assets/VaaniDM_Wordmark.png';
import superAdminPic from '../../assets/super-admin.png';

function Header({ user, onLogout, onToggleNav, navOpen = false }) {
  const displayName = user?.name || 'User';
  const roleLabel = (() => {
    const role = String(user?.role || '').toUpperCase();
    if (role === 'SUPER_ADMIN' || role === 'SUPERADMIN') return 'Super Admin';
    if (role === 'OWNER') return user?.organizationName || user?.business || 'Owner';
    if (role === 'ADMIN') return 'Admin';
    if (role === 'MEMBER') return 'Member';
    return user?.plan || user?.organizationName || user?.business || 'Member';
  })();
  const plan = roleLabel;

  return (
    <header className="custom-header">
      {/* Only rendered below the breakpoint (CSS), where the sidebar is a
          drawer rather than a permanent column. */}
      <button
        type="button"
        className="nav-toggle"
        onClick={onToggleNav}
        aria-label={navOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={navOpen}
      >
        {navOpen ? <FiX /> : <FiMenu />}
      </button>

      <div className="brand-block">
        {/* The wordmark already contains the name and tagline, so no adjacent
            text — repeating it would read as "VaaniDM VaaniDM". */}
        <img src={wordmark} alt="VaaniDM" className="brand-wordmark" />
      </div>

      <div className="page-title"></div>

      <div className="search-bar">
        <FiSearch className="search-icon" aria-hidden />
        <input
          type="text"
          placeholder="Search leads, campaigns, or settings..."
          aria-label="Search"
        />
      </div>

      <div className="header-actions">
        <button className="icon-button" type="button" aria-label="Notifications">
          <FiBell className="bell-icon" />
          <span className="notification-dot" />
        </button>

        <div className="profile-block">
          <div className="profile-info">
            <span className="profile-name">{displayName}</span>
            <span className="profile-plan">{plan}</span>
          </div>
          <img
            src={superAdminPic}
            alt={`${displayName} avatar`}
            className="profile-avatar"
          />
          {onLogout ? (
            <button
              className="icon-button logout-button"
              type="button"
              aria-label="Log out"
              title="Log out"
              onClick={onLogout}
            >
              <FiLogOut className="bell-icon" />
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}

export default Header;
